import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
import { conforms } from "lodash";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      // Request to QNA
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }
      let data = JSON.stringify({
        question: transcript,
        language: "english",
        client: "ottawa",
      });
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        //url: "http://localhost:3050/api/query",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      commit("setIsThinking", true);
      commit("setTextBubbleText", i18n.t("isThinking"));
      axios
        .request(config)
        .then((response) => {
          const qnaAnalytics = {
            timeStamp: new Date(),
            kioskID: getters.getKioskId,
            transcript: transcript,
            result: response.data,
          };
          commit("setTouchRequest", {
            module: "QnA",
            action: transcript,
            response: response.data.response,
            timeStamp: new Date(),
            requestType: "Speech",
          });
          //dispatch('sendQnaData', qnaAnalytics);
          dispatch("addQnaDatatoStrapi", qnaAnalytics);
          dispatch("generateAnswer", response.data.answer);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error);
        });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      console.log("What is the result: ", result);
      if (getters.getIsThinking) {
        commit("setQnaStatus", false);
        const metadata = result.intent.toString();
        const ansObj = result;
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (metadata) {
          case "navigate":
            var menuName = ansObj.metadata.navigateto;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarSpeak", ansObj.answer);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.answer);
            }
            break;

          case "3":
            try {
              console.log("inside show map", i18n.t("maps"));
              var mapPath = i18n
                .t("maps")
                .filter(
                  (map) =>
                    map.displayPosition.toString() ===
                    ansObj.metadata.mappath.toString(),
                );
              console.log("Map Path: ", mapPath);
              var floorName = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapPath[0].mapFloor);
              console.log("Map Path floor Name: ", floorName);
              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
                floor: floorName[0].floorName,
                showQR: false,
                qrUrl: "",
              });
             dispatch("avatarSpeak", ansObj.response)
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase(),
              );
              floorName = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapPath.mapFloor);
              dispatch("openImageViewer", {
                name: mapPath.mapName,
                url: mapPath.mapImage,
                floor: floorName[0].floorName,
                showQR: false,
                qrUrl: "",
              });
              dispatch("avatarSpeak", i18n.t("mapNotFound"));
            }

            break;

          case "4":
            dispatch("avatarSpeak", ansObj.response);
            break;

          case "2":
            commit("setQnaKeyword", "");
            var linkId = ansObj.metadata.linkid;
            commit("setQnaKeyword", linkId);
            dispatch("avatarSpeak", ansObj.response);
            router.addRoute({
              path: "/faqs",
              component: () => import("@/views/faqs"),
            });
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            var page = i18n
              .t("homepages")
              .filter((page) => page.pageType[0].pathName === "faqs");
            commit("setPageHeader", page[0].pageType[0].pageHeader);

            break;

          case "0":
            var followUp = ansObj.metadata.followup.split(",");
            dispatch("avatarSpeak", ansObj.response);
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followUp,
            });
            break;
          default:
            mapPath = getters.getMaps.get(
              getters.getDefaultLocation.toLowerCase(),
            );
            floorName = i18n
              .t("floors")
              .filter((floor) => floor.floorNumber === mapPath.mapFloor);
            dispatch("openImageViewer", {
              name: mapPath.mapName,
              url: mapPath.mapImage,
              floor: floorName[0].floorName,
              showQR: false,
              qrUrl: "",
            });
            dispatch("avatarSpeak", i18n.t("kbError"));
            break;
        }
      }
    },
  },
};
